// #742: the cart upsell slider sources its recommendations from the cart's
// products. Shopify returns cart lines most-recently-added FIRST, so the latest
// addition is the first line — auto-added free-gift lines are skipped so they
// never hijack the recommendation source. Returns raw product gids (caller
// parses).
const isGiftLine = node =>
  node?.attributes?.some(a => a?.key === '_freeItem' || a?.key === '_freeItemDiscountId');

// Every non-gift product gid in the cart, most-recently-added first. The slider
// pools the complementary products of all of these (JW 2026-06-26), with the
// newest leading so adding a product still surfaces its recommendations first.
export function getUpsellSourceProductIds(lines = []) {
  return (lines || [])
    .filter(({ node } = {}) => node?.merchandise?.product?.id && !isGiftLine(node))
    .map(({ node }) => node.merchandise.product.id);
}

export default getUpsellSourceProductIds;
